import { useTranslation } from 'react-i18next'

import { InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text, Tooltip } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InfoTooltip = ({ text }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip
      backgroundColor={theme.colors.text.default}
      title={
        <Text type="bodySRegular" color={theme.colors.text.inverse}>
          {text}
        </Text>
      }
    >
      <Styles.IconContainer role="img" aria-label={t('Información')} tabIndex={0}>
        <InfoIcon size={20} color={theme.colors.text.muted} />
      </Styles.IconContainer>
    </Tooltip>
  )
}

export default InfoTooltip
